import { createContext } from "react";
import { opportunitiesInitialState } from "./opportunitiesInitialState";


const OpportunitiesContext = createContext(opportunitiesInitialState)

export default OpportunitiesContext